<template>
    <div>
        <order-form :entity-id="entityId"></order-form>
    </div>
</template>

<script>
import OrderForm from '@/components/pages/orders/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        OrderForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
